@if (user(); as user) {
    <app-user-form
        mode="edit"
        [initialUser]="user"
        [isSubmitting]="submitting()"
        [canDelete]="canDelete()"
        [lockRole]="isSelf()"
        (formSubmit)="onSubmit($event)"
        (deleteRequested)="onDelete()"
    ></app-user-form>
} @else {
    <div class="loading"></div>
}
